import {
    IAtendimentoClienteRequest,
    IAtendimentoClienteResponse,
    IListarAtendimentoClienteResponse,
    TModoGestaoAtendimento,
} from "../../../Interfaces/AtendimentoCliente/GestaoDeAtendimento/GestaoDeAtendimentoInterfaces";
import Axios from "../../Config/API";
import Service from "../../Service";

export async function ListarAtendimentosClienteService<
    TResponseType extends IListarAtendimentoClienteResponse | Blob
>(
    data: IAtendimentoClienteRequest,
    pagina: number,
    SEG_ATENDIMENTOS: TModoGestaoAtendimento,
    excel?: boolean
) {
    return Service(
        Axios.post<TResponseType>(
            `/atendimentocliente/atendimentos/listaratendimentos?ID_PAGINA=${pagina}&SEG_ATENDIMENTOS=${SEG_ATENDIMENTOS}&excel=${
                excel ?? false
            }`,
            data,
            { responseType: excel ? "blob" : "json" }
        )
    );
}

export async function ListarAtendimentosParaTransferirService(
    data: IAtendimentoClienteRequest,
    pagina: number,
    SEG_ATENDIMENTOS: TModoGestaoAtendimento
) {
    return Service(
        Axios.post<Array<IAtendimentoClienteResponse>>(
            `/atendimentocliente/atendimentos/listaratendimentos?ID_PAGINA=${pagina}&SEG_ATENDIMENTOS=${SEG_ATENDIMENTOS}&excel=${false}`,
            data
        )
    );
}
